import React from "react"
import useSiteMetadata from "../../hooks/use-site-metadata"
import { createMarkup } from "../../../utils/markup-creator"
import Icon from "../icons"
import { stripLeadingCopyright } from "../../../utils/footer-copyright"
import { FooterType, LinkType } from "../../types"

type LayoutProps = {
  footer: FooterType
  [key: string]: any
}

const FooterWeshare = ({ footer }: LayoutProps) => {
  const { siteTitle, footerCopyrightText, footerPhoneNumber } = useSiteMetadata()
  const disclaimerHtml = footerCopyrightText ? stripLeadingCopyright(footerCopyrightText.toString()) : ``

  return (
    <footer className={`bg-darkBrand text-white ${footer.advanced?.class || ``}`}>
      <div className="max-w-screen-xl mx-auto px-6 lg:px-12 py-10 md:py-12">
        <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-8">
          <div className="flex-1 order-2 md:order-1">
            <div className="hidden md:block border-t border-gray-500 mb-6 max-w-md" />
            <p className="text-sm">
              <span className="font-bold">© {new Date().getFullYear()}</span>{" "}
              <span className="text-weshareYellow">Unite Health Share Ministries</span>
              <sup>™</sup>{" "}
              <span className="font-bold">and WeShare<sup>®</sup></span>
            </p>
            {footerPhoneNumber && <p className="mt-4 text-sm">{footerPhoneNumber}</p>}
          </div>
          <div className="flex flex-col items-center md:items-end gap-6 order-1 md:order-2">
            {footer.logo && (
              <img src={footer.logo} alt={siteTitle} style={{ height: `42px`, width: `242px` }} />
            )}
            {footer.links && footer.links.length > 0 && (
              <div className="flex gap-2">
                {footer.links.map((link: LinkType, i: number) => (
                  <a
                    key={`footer-social-${i}`}
                    href={link.url}
                    aria-label={link.description || link.name}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`flex items-center justify-center w-8 h-8 rounded-full bg-gray-700 hover:bg-gray-600 text-darkBrand ${link.class || ``}`}
                  >
                    {link.icon && <Icon icon={link.icon} size={15} />}
                  </a>
                ))}
              </div>
            )}
          </div>
        </div>
        {disclaimerHtml && (
          <div
            className="mt-6 text-sm text-white leading-relaxed max-w-screen-md"
            dangerouslySetInnerHTML={createMarkup(disclaimerHtml)}
          />
        )}
      </div>
    </footer>
  )
}

export default FooterWeshare
